import React from 'react'

interface FlexProps {
  children?: React.ReactNode
  testId?: string
  flexDirection?: 'row' | 'column'
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'initial'
    | 'inherit'
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse'
  alignItems?: 'stretch' | 'center' | 'flex-start' | 'flex-end'
  gap?: string
  flex?: string
}

export const Flex = ({
  testId,
  justifyContent,
  flexDirection,
  flexWrap,
  gap,
  alignItems,
  children,
  flex,
}: FlexProps) => (
  <div
    data-testid={testId}
    style={{
      display: 'flex',
      justifyContent: justifyContent,
      flexDirection: flexDirection,
      flexWrap: flexWrap,
      gap: gap,
      alignItems: alignItems,
      flex: flex,
    }}
  >
    {children}
  </div>
)
